module.exports = __webpack_public_path__ + "static/media/cheques.e7146971.svg";